<template>
  <span class="common-tags" :class="className" :style="styleSheest">
    {{text}}
  </span>
</template>
<script>
import { isNumber } from 'util'
export default {
  props: {
    text: {
      type: String,
      default: '标签'
    },
    className: {
      type: [Array, String],
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      styleSheest: {}
    }
  },
  created () {
    this.initValue()
  },
  methods: {
    initValue () {
      if (this.color !== '') {
        this.styleSheest['color'] = this.color
      }
       if (this.size !== '') {
        this.styleSheest['font-size'] = isNumber(this.size) ? this.size+'px' : this.size
      }
    }
  }
}
</script>
<style lang="less" scoped>
.common-tags {
  border-radius: 2px;
  padding: 0px 3px;
  margin: 2px;
  text-align: center;
  display: inline-flex;
  border: 1px solid #cecece;
  color: #585858;
  font-size: 12px;
}
</style>